var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.85059 21.1496V19.4464H4.85059V4.55398C4.85059 4.09236 5.01946 3.69209 5.35721 3.35315C5.69498 3.0142 6.09385 2.84473 6.55384 2.84473H17.4462C17.9079 2.84473 18.3081 3.0142 18.6471 3.35315C18.986 3.69209 19.1555 4.09236 19.1555 4.55398V19.4464H21.1555V21.1496H2.85059ZM17.4462 19.4464V4.55398H6.55384V19.4464H17.4462ZM14.175 12.7752C14.4159 12.7752 14.6177 12.6937 14.7807 12.5308C14.9436 12.3679 15.025 12.166 15.025 11.9252C15.025 11.6843 14.9436 11.4825 14.7807 11.3196C14.6177 11.1566 14.4159 11.0752 14.175 11.0752C13.9342 11.0752 13.7323 11.1566 13.5694 11.3196C13.4065 11.4825 13.325 11.6843 13.325 11.9252C13.325 12.166 13.4065 12.3679 13.5694 12.5308C13.7323 12.6937 13.9342 12.7752 14.175 12.7752Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoor);
export default __webpack_public_path__ + "static/media/door.00cd1093c611a7976d7c421f5b0d470f.svg";
export { ForwardRef as ReactComponent };